import {createContext} from 'react'

const BajaInventarioContext = createContext()

export default BajaInventarioContext